const fs = require('fs');
const csv = require('csvtojson');
const fileInputName = "assets/earthScienceEducationalResources.csv";

//load the data
const fetchCSV = async fileInputName => {
    let file = await fetch(fileInputName);
    file = await file.text();
    return await csv().fromString(file);
};

//once the data are loaded, then...
fetchCSV(fileInputName).then(json => {

    //default load all data to page
    let multFilter = json;
    displayResources(multFilter)

    //remove loading gif now that content has loaded on page
    let loadGif = document.getElementById("loading");
    loadGif.classList.toggle("hide");

    //record user input for select and input fields
    let gradeButton = document.querySelector('#selectGrade');
    let outGrade = gradeButton.options[gradeButton.selectedIndex].value;
    function alertButtonGrade() {
        gradeButton = document.querySelector('#selectGrade');
        outGrade = gradeButton.options[gradeButton.selectedIndex].value;
    }
    let topicButton = document.querySelector('#selectTopic');
    let outTopic = topicButton.options[topicButton.selectedIndex].value;
    function alertButtonTopic() {
        topicButton = document.querySelector('#selectTopic');
        outTopic = topicButton.options[topicButton.selectedIndex].value;
    }

    //user may select to search based on a time constraint or to ignore time constraints
    let checkButton = document.querySelector('#selectTimeNoTime');
    let outCheck = 'Ignore';
    function alertButtonCheck() {
        if (this.checked) {
            outCheck = 'None';
        } else {
            outCheck = 'Ignore';
        }
    }
    let timeButton = document.querySelector('#selectTime');
    let outTime = document.getElementById("selectTime").value;
    function alertButtonTime() {
        timeButton = document.querySelector('#selectTime');
        outTime = document.getElementById("selectTime").value;
    }

    //respond to user hitting the submit button
    let runFilterButton = document.querySelector('#runFilter');
    function alertButtonGetResults() {

        //clear previous container
        const oldResults = document.getElementById("container");
        oldResults.remove();

        //bring back loading gif
        loadGif.classList.toggle("hide");

        //define choice if user did not choose a filter or if they only selected certain filters
        //but first find out if the time constraint box is checked or not, or if a time constraint
        //is provided, and respond accordingly
        if (outCheck === 'Ignore' && outTime !== "") {
            if (outGrade === 'None' && outTopic === 'None') {
                multFilter = json.filter(x => x.Time <= Number(outTime));
            } else if (outGrade === 'None' && outTopic !== 'None') {
                //multFilter = json.filter(x => x.Topic === outTopic && x.Time <= Number(outTime));
                multFilter = json.filter(x => x.Topic.includes(outTopic) && x.Time <= Number(outTime));
            } else if (outGrade !== 'None' && outTopic === 'None') {
                //multFilter = json.filter(x => x.Grade === outGrade && x.Time <= Number(outTime));
                multFilter = json.filter(x => x.Grade.includes(outGrade) && x.Time <= Number(outTime));
            } else {
                //multFilter = json.filter(x => x.Grade === outGrade && x.Topic === outTopic && x.Time <= Number(outTime));
                multFilter = json.filter(x => x.Grade.includes(outGrade) && x.Topic.includes(outTopic) && x.Time <= Number(outTime));
            }
        } else {
            const maxTime = Math.max.apply(Math,(json.map((x) => {return x.Time})));
            if (outGrade === 'None' && outTopic === 'None') {
                multFilter = json.filter(x => x.Time <= maxTime);
            } else if (outGrade === 'None' && outTopic !== 'None') {
                multFilter = json.filter(x => x.Topic.includes(outTopic) && x.Time <= maxTime);
            } else if (outGrade !== 'None' && outTopic === 'None') {
                multFilter = json.filter(x => x.Grade.includes(outGrade) && x.Time <= maxTime);
            } else {
                multFilter = json.filter(x => x.Grade.includes(outGrade) && x.Topic.includes(outTopic) && x.Time <= maxTime);
            }
        }

        //check for no results and print message if there aren't any
        let noResultsMsg = document.getElementById("noResults");
        if (multFilter.length === 0) {
            noResultsMsg.classList.remove("hide");
        }
        else {
            noResultsMsg.classList.add("hide");
        }

        //filter the data and display the results
        displayResources(multFilter);

        //remove loading gif now that data are displayed
        loadGif.classList.toggle("hide");
    }

    //event listeners for filters and the submit button
    gradeButton.addEventListener("change", alertButtonGrade, false);
    topicButton.addEventListener("change", alertButtonTopic, false);
    timeButton.addEventListener("change", alertButtonTime, false);
    checkButton.addEventListener("change", alertButtonCheck, false);
    runFilterButton.addEventListener("click", alertButtonGetResults, false);

    //display resources, whether filtered or not, as images with links
    function displayResources(multFilter) {
        const container = document.createElement('div');
        container.className = "container";
        container.id = "container";
    
        multFilter.forEach(resource => {
            const filteredResource = document.createElement('a');
            filteredResource.href = resource.Link;
            filteredResource.target = "_blank";
            filteredResource.classList.add("item", "hoverImg");
    
            const imageContainer = document.createElement('div');
            imageContainer.className = "imageContainer";
    
            const pic = document.createElement('img');
            pic.src = resource.Image;
            pic.alt = resource.Name;
            pic.className = "centerImage";
    
            // If you have videos instead of images
            // const video = document.createElement('video');
            // video.src = resource.Video;
            // video.className = "centerVideo";
            // video.controls = true;
    
            imageContainer.appendChild(pic);
            // imageContainer.appendChild(video); // For video instead of image
    
            const resourceName = document.createElement('p');
            resourceName.classList.add("centerText", "title");
            resourceName.textContent = resource.Name;

            const description = document.createElement('p');
            description.classList.add("centerText", "description");
            description.innerHTML = ` ${resource.Description}`;
    
            const grade = document.createElement('p');
            grade.classList.add("centerText", "badge");
            grade.innerHTML = `<strong>Grades:</strong> ${resource.Grade}`;
    
            const topic = document.createElement('p');
            topic.classList.add("centerText", "badge");
            topic.innerHTML = ` <strong>Topic:</strong> ${resource.Topic}`;
    
            const standards = document.createElement('p');
            standards.classList.add("centerText", "badge");
            standards.innerHTML = `<strong>NGSS Standards:</strong> ${resource["NGSS Standards"]}`;
    
            const source = document.createElement('p');
            source.classList.add("centerText", "badge");
            source.innerHTML = `<strong>Source:</strong> ${resource.Source}`;
    
            filteredResource.append(imageContainer, resourceName, description, grade, topic, standards, source);
            container.appendChild(filteredResource);
        });
    
        const main = document.getElementById("mainContent");
        main.appendChild(container);
    }    
    
})
